(function () {

    'use strict';

    angular.module('Services').factory('BBAProfileManagerTableService', BBAProfileManagerTableService);
    BBAProfileManagerTableService.$inject = [
        '$location',
        'BBAProfileManagerService',
        'TableLiteFactory',
        'toastr',
        'Units',
        '$rootScope'];

    function BBAProfileManagerTableService($location,
                                           BBAProfileManagerService,
                                           TableLiteFactory,
                                           toastr,
                                           Units,
                                           $rootScope) {
        return function () {
            const measureUnit = Units.getMeasureUnit($rootScope.GlobalProfile.office.measureUnit);
            const tableData = {
                tableName: 'bbaProfileTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add new',
                        tooltip: 'Add new BBA profile',
                        onClick: function () {
                            $location.path('/bba-profile-manager/add');
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                },
                headers: [{
                    label: 'BBA Profile Name',
                    viewName: 'name',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'First Mile Carrier',
                    viewName: 'firstMileCarrierName',
                    filterName: 'firstMileCarrierName',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Line Haul Provider',
                    viewName: 'lineHaulProviderName',
                    filterName: 'lineHaulProviderName',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Last Mile Carrier',
                    viewName: 'lastMileCarrierName',
                    filterName: 'lastMileCarrierName',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }],
                data: []
            };
            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: BBAProfileManagerService.getAll,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                if (!data)
                    return null;
                angular.forEach(data.content, function (row, index) {
                    row.firstMileCarrierName = row.firstMileCarrier && row.firstMileCarrier.name || 'N/A';
                    row.lineHaulProviderName = row.lineHaulProvider && row.lineHaulProvider.name || 'N/A';
                    row.lastMileCarrierName = row.lastMileCarrier && row.lastMileCarrier.name || 'N/A';
                    row.href = '/bba-profile-manager/' + row.id;
                    tableData.data.push(row);
                });
                /*** END - Building of Data ***/
            }

            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/BBAProfileManagerTableService.js